// extracted by mini-css-extract-plugin
module.exports = {"inputRoot":"button-storeIn-cloud_inputRoot__20icL","inputWrapper":"button-storeIn-cloud_inputWrapper__9DXGN","icon":"button-storeIn-cloud_icon__2O0s7"};